import type { MouseEvent } from 'react';

import { withRtlSupport } from '@skyscanner/backpack-web/bpk-component-icon';
import BpkSmallChevronLeftIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/chevron-left';
import BpkSmallCloseIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/close';
import BpkNavigationBar, {
  BpkNavigationBarIconButton,
} from '@skyscanner/backpack-web/bpk-component-navigation-bar';
import BpkText from '@skyscanner/backpack-web/bpk-component-text';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import { withI18n } from '../../../contexts/i18n';

import type { I18nService } from '@shared/types/i18n';

import STYLES from './BackHeader.module.scss';

type Props = {
  i18n: I18nService;
  onClick: (event: MouseEvent<HTMLElement>) => void;
  showClose?: boolean;
  className?: string;
  buttonClassName?: string;
  title?: string;
  opacity?: number;
};

const AlignedChevronLeft = withRtlSupport(BpkSmallChevronLeftIcon);
const AlignedClose = withRtlSupport(BpkSmallCloseIcon);

const cls = cssModules(STYLES);

const BackHeader = ({
  buttonClassName,
  className,
  i18n: { translate },
  onClick,
  opacity = 1,
  showClose,
  title,
}: Props) => {
  const CloseIcon = showClose ? AlignedClose : AlignedChevronLeft;

  return (
    <BpkNavigationBar
      id="back-header-in-full-screen-wrapper"
      className={cls('BackHeader', className)}
      title={
        title && (
          <BpkText tagName="p" style={{ opacity }}>
            {title}
          </BpkText>
        )
      }
      sticky
      leadingButton={
        <BpkNavigationBarIconButton
          data-testid="back-header"
          className={cls('BackHeader__button', buttonClassName)}
          onClick={onClick}
          icon={CloseIcon}
          label={translate('PageErrorBoundary_ErrorCard_button')}
        />
      }
    />
  );
};

export default withI18n(BackHeader);
